const removeDuplicates = (array: Array<any>) => {
  return array.filter(
    (v: any, i: number, arr: Array<any>) =>
      arr.findIndex((vv: any) => vv === v) === i,
  )
}

export default removeDuplicates
